<template>
  <div class="tableLoaderContainer">

    <div class="BodyTitle">
      <div class="BodyTitleText">调拨入库</div>
    </div>

    <div class="searchContentContainer">
      <div class="searchItemContainer">
        <label class="searchinputLabel" for="OutWarehouseIdForStOnTheWayList">出库仓库:</label>
        <div class="searchInputBox" :class="{'ActiveBox':activeInput == 'OutWareHouseId'}"><select v-model="SearchContent.OutWareHouseId" class="searchinput" id="OutWarehouseIdForStOnTheWayList" @focus="setActiveId('OutWareHouseId')" @blur="setActiveId('')" @change="reSearch()">
            <option value="">所有</option>
            <option v-for="item in OutWarehouseFilter" :key="item.beforeTransfer + 'StOnTheWayList' + 'OutWarehouse'" :value="item.beforeTransfer">{{item.afterTransfer}}</option>
          </select></div>
      </div>
      <div class="searchItemContainer">
        <label class="searchinputLabel" for="DocumentDateLStOnTheWayList">发起日期</label>
        <div class="searchInputBox" :class="{'ActiveBox':activeInput == 'DocumentDateL'}"><input v-model="SearchContent.DocumentDateL" class="searchinput" id="DocumentDateLStOnTheWayList" type="date" @focus="setActiveId('DocumentDateL')" @blur="setActiveId('')"></div>
      </div>
      <div class="searchItemContainer">
        <label class="searchinputLabel" for="DocumentDateHStOnTheWayList" v-text="'---'"></label>
        <div class="searchInputBox" :class="{'ActiveBox':activeInput == 'DocumentDateH'}"><input v-model="SearchContent.DocumentDateH" class="searchinput" id="DocumentDateHStOnTheWayList" type="date" @focus="setActiveId('DocumentDateH')" @blur="setActiveId('')"></div>
      </div>
      <div class="searchItemContainer">
        <label class="searchinputLabel" for="CommodityNameStOnTheWayList">商品名称:</label>
        <div class="searchInputBox" :class="{'ActiveBox':activeInput == 'CommodityName'}"><input v-model="SearchContent.CommodityName" class="searchinput long" id="CommodityNameStOnTheWayList" type="text" @focus="setActiveId('CommodityName')" @blur="setActiveId('')"></div>
      </div>

      <div class="searchItemContainer">
        <label class="searchinputLabel" for="CommodityIdStOnTheWayList">商品编码:</label>
        <div class="searchInputBox" :class="{'ActiveBox':activeInput == 'CommodityId'}"><input v-model="SearchContent.CommodityId" class="searchinput" id="CommodityIdStOnTheWayList" type="text" @focus="setActiveId('CommodityId')" @blur="setActiveId('')"></div>
      </div>

      <!-- 搜索模块 -->
      <div class="FuncButton" @click="searchList()">搜索</div>
    </div>

    <div class="BigTable">
      <div class="TableContentArea">
        <table class="tablehead">
          <tr class="headtr" :style="{ height : trHeight }">
            <th class="thSN">
              <div :style="{ width: SnWidth }"></div>
            </th>
            <th class="thselectall">
              <div :style="{ width: selectAllWidth }"><input class="selectAllCheckBox" type="checkbox" v-model="selectAll" /></div>
            </th>
            <th>
              <div class="thoper" :style="{ width: operationWidth }">操作</div>
            </th>
            <th class="headtd" v-for="value1 in tableHead" :key="value1.fieldsNameForVali + 'head'" :class="{  ShowUpArrow: searchElement.SortFieldsName.toLowerCase() ==  value1.fieldsNameForVali.toLowerCase() && searchElement.SortDirection == 1, ShowDownArrow: searchElement.SortFieldsName.toLowerCase() ==  value1.fieldsNameForVali.toLowerCase() && searchElement.SortDirection == -1,}" @click.stop="ChangeSort(value1.fieldsNameForVali)">
              <div :style="{ width: value1.showLen  + 'rem' }">{{ value1.showName }}</div>
            </th>
          </tr>
        </table>
        <div class="tablebodyarea" :style="{ width: tablewidth  + 'rem',height:tbodyHeight}">
          <table class="tablebody">
            <tr class="bodytr" v-for="(value2, index2) in tableBody" :key="'td' + index2" :class="[{todoLine:value2.supplierToBeSolve},{nottodoLine:!value2.supplierToBeSolve}]">
              <td>
                <div class="tdSN" :style="{ width: SnWidth }">{{+index2 + 1}}</div>
              </td>
              <td class="tableselect">
                <div :style="{ width: selectAllWidth }"><input type="checkbox" :value="value2['stOnTheWayCode']" v-model="selectedItems" /></div>
              </td>
              <td>
                <div class="tdoper" :style="{ width: operationWidth }">
                  <span class="spantt" @click="stInOne(index2)">入库</span>
                  <span class="spancancel" @click="stRefuseOne(index2)" v-show="false">拒绝</span>
                </div>
              </td>
              <td v-for="value3 in tableHead" :key="value3.fieldsNameForVali + 'td'">
                <div :style="{ width: value3.showLen  + 'rem' }">{{ value2[value3.fieldsNameForVali] }}</div>
              </td>
            </tr>
          </table>
        </div>
        <table class="tablefoot">
          <tr class="foottr" :style="{ height : trHeight }">
            <td>
              <div class="footsum" :style="{ width: SnWidth }">合计</div>
            </td>
            <td>
              <div :style="{ width: selectAllWidth }"></div>
            </td>
            <td>
              <div :style="{ width: operationWidth }"></div>
            </td>
            <td v-for="value4 in tableHead" :key="value4.fieldsNameForVali + 'foot'">
              <div :style="{ width: value4.showLen  + 'rem' }"></div>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="moreFunctionBox">
      <el-button class="firstButton" type="primary" @click="stInMany()">批量入库</el-button>
      <el-button type="danger" @click="stRefuseMany()">批量拒绝</el-button>

    </div>
  </div>
</template>

<script>
import { computed, reactive, ref, watch } from 'vue-demi';
import { useStore } from "vuex";
import {
  ChangeFirToLo, ChangeFirToUp, ChangeYMD, changeArrContentToDate, insertSearchOrigin, getInventory, getSalePrice, copyMap
} from '@/hooks/tools';
import _ from "lodash";
import requestData from '@/hooks/requestData';
import {
  fillDefaultValue, changeToViewCode, transferToCode, checkTtCompany, rejectPurchaseApply, getDocNo,
  openTtList, openSoList, deleteDocCenter, updateTtOut, updateSoOut, transferToName, refuseStOnTheWay, inStockStOnTheWay
} from '@/hooks/OpenOrder'
import { ElMessage } from 'element-plus'
export default {
  setup(props, { emit }) {
    //#region 定义区
    const store = useStore();

    const filterList = store.state.loginInitializeData.filterList

    const OutWarehouseFilter = filterList.OutWareHouseId

    //初始化输入表名称
    const TableName = 'StOnTheWayList';

    const PageName = 'StOnTheWayList'

    const code = changeToViewCode(PageName)

    //#endregion

    //#region 全选
    let selectAll = ref(false);

    let selectedItems = ref([]);

    watch(selectAll, (newValue, oldValue) => {
      if (code == store.state.loginInitializeData.ShowWindow[0]) {
        if (newValue == true) {
          selectedItems.value.splice(0);
          for (let item of tableBody) {
            selectedItems.value.push(item['stOnTheWayCode']);
          }
        } else {
          selectedItems.value.splice(0);
        }
      }
    });

    //#endregion

    //#region 输入模块
    //f存入活跃单元格数据
    let activeInput = reactive({
      activeIndex: -1,
      activeFields: ''
    })
    let enterInValue = ref('');

    const saveEnterInValue = (value) => {
      setTimeout(() => {
        enterInValue.value = value
      }, 200)
    }
    //#endregion

    watch(() => activeInput.activeIndex, () => {
      searchResult.splice(0)
    })
    const setActiveInput = (index, fields) => {
      activeInput.activeIndex = index;
      activeInput.activeFields = fields;
    }

    //#endregion
    watch(() => store.state.loginInitializeData.ShowWindow[0],
      (newValue, oldValue) => {
        if (code == store.state.loginInitializeData.ShowWindow[0]) {
          searchList()
        }
      }
    )


    const setActiveId = (id) => {
      activeInput.value = id
    }
    let selectAllWidth = ref('2.5rem')
    let trHeight = ref('1.875rem')
    let SnWidth = ref('3.75rem')
    let operationWidth = ref('8rem')
    let tbodyHeight = ref('calc(100% - 3.75rem)')

    let SearchContent = reactive({
      StOnTheWayCode: '',
      DocumentId: '',
      Sn: '',
      PartACompanyId: '',
      OutWareHouseId: '',
      InWareHouseId: '',
      DocumentDateL: '',
      DocumentDateH: '',
      DocumentType: '',
      CommodityName: '',
      CommodityId: '',
      Remark: '',
      OrderQty: '',
      UnitPrice: '',
    })
    fillDefaultValue(SearchContent, TableName)

    //f计算表格内容总宽度
    let tablewidth = computed(() => {
      return (
        parseFloat(SnWidth.value) +
        parseFloat(operationWidth.value) +
        parseFloat(selectAllWidth.value) + 1.25 + tableHead.length * 1 + 0.25 +
        tableHead.reduce((ac, cu) => {
          return ac + cu.showLen;
        }, 0)
      );
    });

    let tableHead = reactive([
      { fieldsNameForVali: 'documentId', showLen: 12.5, showName: '单据Id' },
      { fieldsNameForVali: 'sn', showLen: 2.5, showName: '序' },
      { fieldsNameForVali: 'inWareHouseId', showLen: 7.5, showName: '入库仓库' },
      { fieldsNameForVali: 'commodityName', showLen: 25, showName: '商品名称' },
      { fieldsNameForVali: 'orderQty', showLen: 3.75, showName: '数量' },
      { fieldsNameForVali: 'documentDate', showLen: 10, showName: '单据日期' },
      { fieldsNameForVali: 'commodityId', showLen: 10, showName: '商品Id' },
      { fieldsNameForVali: 'outWareHouseId', showLen: 7.5, showName: '来源仓库' },
      { fieldsNameForVali: 'remark', showLen: 18.75, showName: '备注' },
    ]);

    const searchElement = reactive({
      SortFieldsName: 'DocumentDate',
      SortDirection: 1
    })

    let tableBody = reactive([]);

    let ChangeSort = (fildsname) => {
      searchElement.SortFieldsName = ChangeFirToUp(fildsname)
      searchElement.SortDirection = -searchElement.SortDirection
      searchList()
    };

    const reSearch = () => {
      searchList()
    }


    const searchList = () => {
      
      let config = {
        method: "post",
        url: '/StOnTheWayList/GetListByMulSearchForStIn',
        data: Object.assign(SearchContent, searchElement),
      };
      requestData
        .GetData(config)
        .then((res) => {
          selectAll.value = false
          selectedItems.value.splice(0)
          tableBody.splice(0);
          tableBody.push.apply(tableBody, res['stOnTheWayListMultiple']);
          changeArrContentToDate(tableBody, PageName)
          const filterList = store.state.loginInitializeData.filterList
          const warehouseFilter = filterList.WareHouseId
          for (let item of tableBody) {
            for (let key in item) {
              if (key == 'outWareHouseId') {
                item[key] = warehouseFilter.find(x => x.beforeTransfer == item[key])?.afterTransfer
              }
              if (key == 'inWareHouseId') {
                item[key] = warehouseFilter.find(x => x.beforeTransfer == item[key])?.afterTransfer
              }
            }
          }
          
        })
        .catch((err) => {
          
          ElMessage(err.message)
        });
    };
    searchList()

    const inStockAction = (indexs) => {
      return new Promise(function (resolve, reject) {
        let promiseArr = []
        for (let index of indexs) {
          let b = inStockStOnTheWay(tableBody[index].stOnTheWayCode)
          promiseArr.push(b)
        }
        Promise.all(promiseArr).then(resArr => {
          resolve(resArr)
        })
      })
    }

    const refuseAction = (indexs) => {
      return new Promise(function (resolve, reject) {
        let promiseArr = []
        for (let index of indexs) {
          let b = refuseStOnTheWay(tableBody[index].stOnTheWayCode)
          promiseArr.push(b)
        }
        Promise.all(promiseArr).then(resArr => {
          resolve(resArr)
        })
      })
    }


    const stInOne = (index) => {
      
      let b = confirm('确认入库')
      if (!b) {
        
        return false;
      }
      let indexs = []
      indexs.push(index)
      inStockAction(indexs).then(resArr => {
        if (!resArr) {
          
          ElMessage('入库失败')
          return false;
        }
        if (resArr[0] != 'pass') {
          
          ElMessage(`销售开单失败,原因是${resArr[0]}`)
          return false;
        }
        else {
          
          searchList()
          emit('refreshMsg')
        }
      }).catch(err=>{
        
        ElMessage(err.message)
      })
    }

    const stRefuseOne = (index) => {
      
      let b = confirm('确认取消,取消后无法恢复')
      if (!b) {
        
        return false;
      }
      let indexs = []
      indexs.push(index)
      refuseAction(indexs).then(resArr => {
        if (!resArr) {
          
          ElMessage('取消失败')
          return false;
        }
        if (resArr[0] != 'pass') {
          
          ElMessage(`取消失败,原因是${resArr[0]}`)
          return false;
        }
        else {
          
          searchList()
          emit('refreshMsg')
        }
      }).catch(err=>{
        
        ElMessage(err.message)
      })
    }

    const stInMany = () => {
      
      if (selectedItems.value.length == 0) {
        
        ElMessage('未选择行')
        return;
      }
      let b = confirm('确认入库')
      if (!b) {
        
        return false;
      }
      let arrLength = tableBody.length
      let indexArr = []
      for (let i = 0; i < arrLength; i++) {
        if (selectedItems.value.indexOf(tableBody[i].stOnTheWayCode) > -1) {
          indexArr.push(i)
        }
      }
      inStockAction(indexArr).then(res => {
        
        searchList()
        emit('refreshMsg')
      }).catch(err=>{
        
        ElMessage(err.message)
      })
    }

    const stRefuseMany = () => {
      
      if (selectedItems.value.length == 0) {
        
        ElMessage('未选择行')
        return;
      }
      let b = confirm('确认取消,取消后无法恢复')
      if (!b) {
        
        return false;
      }
      let arrLength = tableBody.length
      let indexArr = []
      for (let i = 0; i < arrLength; i++) {
        if (selectedItems.value.indexOf(tableBody[i].stOnTheWayCode) > -1) {
          indexArr.push(i)
        }
      }
      refuseAction(indexArr).then(res => {
        
        searchList()
        emit('refreshMsg')
      }).catch(err=>{
        
        ElMessage(err.message)
      })
    }




    return {
      setActiveId,
      trHeight, SnWidth, operationWidth, tableHead, searchList, ChangeSort, tablewidth, tableBody,
      reSearch, searchElement, tbodyHeight, SearchContent, selectAllWidth,
      selectAll, selectedItems, activeInput, setActiveInput, saveEnterInValue,
      OutWarehouseFilter, stInOne, stRefuseOne, stInMany, stRefuseMany


    }
  },
  components: {
  }
}
</script>

<style scoped lang="less">
.tableLoaderContainer {
  width: 100%;
  height: 100%;
}
.moreFunctionBox {
  margin-top: 2rem;
  width: 100%;
  height: 2rem;
  display: flex;
  flex-wrap: wrap;
}

@bigContainerMarginTop: 0.5rem;
@smallToBigGap: 0.6rem;
@lableMarginLeft: 0.625rem;
@lableHeight: 2rem;
@inputHeight: 1.5rem;
@mainColor: #4285f4;

.searchContentContainer {
  width: 98%;
  margin-top: @bigContainerMarginTop;
  margin-left: 1%;
  border: 1px solid #cccccc;
  border-radius: 5px;
  display: flex;
  flex-wrap: wrap;
}
.searchinputLabel {
  margin-left: @lableMarginLeft;
  font-size: 0.8rem;
  height: @lableHeight;
  line-height: @lableHeight;
}
.searchinput {
  margin-top: calc((@lableHeight - @inputHeight) / 2);
  margin-bottom: calc((@lableHeight - @inputHeight) / 2);
  font-size: 0.9rem;
  border: none;
  outline: none;
  height: @inputHeight;
  line-height: @inputHeight;
}
.ActiveBox {
  border: 1px solid #ffa004 !important;
}

.searchInputBox {
  height: @lableHeight;
  border: 1px solid #c9c9c9;
  margin-left: @lableMarginLeft;
  border-radius: 0.31rem;
}

.searchItemContainer {
  margin-top: @smallToBigGap;
  margin-bottom: @smallToBigGap;
  display: flex;
}

.searchSetting {
  margin-left: calc(@lableMarginLeft*3);
  height: @lableHeight;
  display: flex;
  margin-top: @smallToBigGap;
  margin-bottom: @smallToBigGap;
}
.searchSetting:hover {
  cursor: pointer;
  color: @mainColor;
}
.settingIcon {
  font-family: "icomoon";
  font-size: 1.1rem;
  line-height: @lableHeight;
}

.settingText {
  margin-left: 0.3rem;
  font-size: 0.8rem;
  line-height: @lableHeight;
}
.dateInputContainer {
  display: flex;
}
.BodyTitle {
  width: 98%;
  margin-top: 0.5rem;
  margin-left: 1%;
}
.BodyTitleText {
  font-size: 1.2rem;
  font-weight: 200;
}
.long {
  width: 20rem;
}

.BigTable {
  width: 98%;
  margin-left: 1%;
  height: 60%;
  margin-top: 1rem;
}
.TableContentArea {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  overflow-x: auto;
}
.headtr {
  background-color: #1e87f0;
  // top: -20px;
  color: #fff;
}
.thSN {
  font-family: "icomoon";
  color: #fff;
  font-size: 16px;
}
.headtd {
  cursor: pointer;
}
.ShowUpArrow {
  position: relative;
}
.ShowUpArrow::after {
  content: "\ea32";
  font-family: "icomoon";
  position: absolute;
  font-size: 1rem;
  right: 0px;
  top: 0.2rem;
  color: #fff;
}
.ShowDownArrow {
  position: relative;
}
.ShowDownArrow::after {
  content: "\ea36";
  font-family: "icomoon";
  position: absolute;
  font-size: 1rem;
  right: 0px;
  top: 0.2rem;
}
.tablebodyarea {
  overflow: hidden;
  overflow-y: auto;
}
.tablebody {
  margin-top: -1px;
}
.tablebody tr:nth-child(even) {
  background-color: #fafafa;
}
.tablebody tr:hover {
  background-color: #edf4fe;
}
.tdSN,
.tableselect,
.tdoper,
.footsum,
.bodytr {
  text-align: center;
}
.bodytr {
  height: 2rem;
}

.spancancel,
.spansale,
.spantt {
  display: inline-block;
  height: 1.25rem;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  cursor: pointer;
  color: #fff;
  border-radius: 5px;
  line-height: 1.25rem;
  font-size: 0.5rem;
  margin-left: 0.5rem;
}
.spantt {
  background-color: #409eff;
}
.spansale {
  background-color: #ffb30f;
}
.spancancel {
  background-color: #fa2c2c;
}
.tablefoot {
  margin-top: -1px;
}

.moreFunctionBox {
  width: 100%;
  height: 2rem;
  display: flex;
  flex-wrap: wrap;
}

.selectAllCheckBox {
  cursor: pointer;
}
.commodityTr {
  position: relative;
}
.tableinputContainer {
  display: flex;
  position: relative;
}
.bodytr input {
  border: none;
  outline: none;
  height: 1.875rem;
  background-color: transparent;
  text-align: center;
}
.bodytr input:focus {
  border: 1px solid #ffa004;
}
.CommodityContainer {
  position: absolute;
  background-color: #fff;
  z-index: 2;
  margin-top: 1px;
  border: 1px solid #cccccc;

  // border-left: 2px solid #4e71f2;
  // border-right: 2px solid #4e71f2;
  // border-bottom: 2px solid #4e71f2;
}
.searchContentTr {
  display: flex;
}
.searchContentTr:hover {
  background-color: #fff;
  background-color: #f5f5f6;
}
.searchContentTr input {
  text-align: left;
}

.searchContentTr input:hover {
  cursor: pointer;
}
.searchContentTrLast:hover {
  background-color: #fa2c2c;
  color: #fff;
  cursor: pointer;
}
.searchContentTrLast {
  padding-left: 0.3rem;
  text-align: left;
}
.checkbo {
  margin-left: 0.2rem;
  cursor: pointer;
}
.headtdEdit {
  cursor: pointer;
}
.highInput {
  background-color: #d9e1f2 !important;
}
.firstButton {
  margin-left: 1rem;
}
</style>